export const isActualPlatform = (platform) => {
    return platform === process.env.REACT_APP_PLATFORM;
}